(function () {
  // #region Global
  const isCartPage = window.location.href.indexOf("/cart") > -1;
  const isDesktop = $(window).width() >= 1024;

  window.custom = window.custom || {};

  function calculateHeaderHeight() {
    setInterval(() => {
      $(":root").css("--nav-height", `${$(".site-header").height()}px`);
      $(":root").css("--top-banner-height", `${$(".top_notice_section").height()}px`);
      $(":root").css("--grey-navbar-height", `${$(".nav2").height()}px`);
    }, 1000);
  }
  // #endregion

  // #region Collection page
  // #endregion

  // #region Product page
  function handleShopWithClimateVoucher() {
    $(".climate-voucher__atc").on("click", function () {
      const initialHTML = this.innerHTML;
      this.innerHTML = "Loading...";

      const atcBtns = document.querySelectorAll(
        "#AddToCart-button, #AddToCart-button-main",
      );
      window.discountOnCartProApp.applyCode("CLIMATE400");
      setTimeout(() => {
        atcBtns[0].click();
        this.innerHTML = initialHTML;
      }, 1000);
    });
  }

  function handleClimateVoucherPopup() {
    $(".climate-voucher-tooltip").on("mouseenter", function () {
      $(".cv-info-container").addClass("show");
    });
    $(".cv-info-close").on("click", function () {
      $(this).closest(".cv-info-container").removeClass("show");
    });
    $(".cv-info-box").on("click", function (event) {
      event.stopPropagation();
    });
    $(".cv-info-container").on("click", function () {
      $(this).removeClass("show");
    });
  }

  function handleProductUpsellBlock() {
    function updateLinks(variantId = null) {
      const atcButton = $("#AddToCart-button");
      const checkoutButton = $("#initateCheckout");
      const currentSelection = $("#currentSelection").attr("data-variant");
      const qty = $("#aura-qty").val();

      if (variantId) {
        atcButton.attr(
          "href",
          `${window.location.origin}/cart/add?id[]=${currentSelection}&id[]=${variantId}&quantity=${qty}`,
        );
        checkoutButton.attr(
          "href",
          `${window.location.origin}/cart/${currentSelection}:${qty},${variantId}:1`,
        );
      } else {
        atcButton.attr(
          "href",
          `${window.location.origin}/cart/add?id[]=${currentSelection}&quantity=${qty}`,
        );
        checkoutButton.attr(
          "href",
          `${window.location.origin}/cart/${currentSelection}:${qty}`,
        );
      }
    }

    function updatePrice() {
      const upsellBlock = $(".product-upsell-block");
      const value = upsellBlock
        .find(".product-upsell-form select:not(.hide)")
        .val();
      const option = upsellBlock.find(
        `.product-upsell-form select option[value="${value}"]`,
      );
      const price = upsellBlock.find(".product-prices .price");
      const total = upsellBlock.find(".product-prices .total");

      let priceNum = 0;
      let totalNum = 0;

      if (value) {
        const dataPrice = option.attr("data-price");
        const dataFreq = option.attr("data-frequency");

        priceNum = theme.Currency.formatMoney(
          dataPrice / dataFreq,
          theme.moneyFormat,
        );
        totalNum = theme.Currency.formatMoney(dataPrice, theme.moneyFormat);
      }

      price.text(priceNum);
      total.text(totalNum);
    }

    function handleDynamicText() {
      const selectElement = $(
        ".product-upsell-block .product-upsell-form select:not(.hide)",
      );
      const dataSets = selectElement.attr("data-sets-select");
      const dataFreq = selectElement
        .find(`option[value="${selectElement.val()}"]`)
        .attr("data-frequency");

      function hideText() {
        $(
          ".product-upsell-block .product-upsell-inner .description ul li.dynamic",
        ).addClass("hide");
      }

      if (dataSets == "4" && dataFreq == "4") {
        hideText();
      } else if (dataSets == "2" && dataFreq == "2") {
        hideText();
      } else {
        $(
          ".product-upsell-block .product-upsell-inner .description ul li.dynamic",
        ).removeClass("hide");
      }
    }

    $(".product-upsell-block .actions .tickContainer").on("click", function () {
      const upsellBlock = $(this).closest(".product-upsell-block");
      upsellBlock.toggleClass("selected");

      if (upsellBlock.hasClass("selected")) {
        const selectedVariant = upsellBlock.find("select:not(.hide)").val();
        updateLinks(selectedVariant);
      } else {
        updateLinks();
      }
    });

    $(".product-upsell-block .product-upsell-form .btn").on(
      "click",
      function () {
        $(".product-upsell-block .product-upsell-form .btn").removeClass(
          "selected",
        );
        $(this).addClass("selected");

        const dataSets = $(this).attr("data-sets");
        $(".product-upsell-block .product-upsell-form select").addClass("hide");
        $(
          `.product-upsell-block .product-upsell-form select[data-sets-select="${dataSets}"]`,
        ).removeClass("hide");

        updatePrice();
        handleDynamicText();
      },
    );

    $(".product-upsell-block .product-upsell-form select").on(
      "change",
      function () {
        const upsellBlock = $(this).closest(".product-upsell-block");

        updatePrice();
        handleDynamicText();

        if (upsellBlock.hasClass("selected")) {
          const selectedVariant = upsellBlock.find("select:not(.hide)").val();
          updateLinks(selectedVariant);
        } else {
          updateLinks();
        }
      },
    );

    // $(".filter-subscription-tooltip").on("mouseenter", function () {
    //   $(".filter-subscription-popup-container").addClass("show");
    // });
    // $(".filter-subscription-popup-close").on("click", function () {
    //   $(this)
    //     .closest(".filter-subscription-popup-container")
    //     .removeClass("show");
    // });
    // $(".filter-subscription-popup-box").on("click", function (event) {
    //   event.stopPropagation();
    // });
    // $(".filter-subscription-popup-container").on("click", function () {
    //   $(this).removeClass("show");
    // });
  }

  function handleAPFilterSubscription() {
    const box = $(".ap-filter-sub-box-wrap");
    const wrapper = box.find(".ap-filter-sub-wrapper");
    const selectorMonth = wrapper.find(".selector-month");
    const selectorVariants = wrapper.find(".selector-variant");
    const input = box.find('input[name="bundle_prod"]');
    const clickBtn = box.find(".click-plus");

    const updatePrice = () => {
      const totalOriPriceElem = box.find(".oldPrice2");
      const totalPriceElem = box.find(".newprice");
      const singlePriceElem = box.find(".singleprice");

      const selectorVariant = wrapper.find(".selector-variant:not(.hide)");

      input.val(selectorVariant.val());
      if (clickBtn.hasClass("clicked")) {
        clickBtn.click();
        clickBtn.click();
      }

      const selectedOption = selectorVariant.find(":selected");
      const dataPrice = selectedOption.data("price");
      const dataFreq = selectedOption.data("frequency");
      const dataOriPrice = totalOriPriceElem.data("originalPrice");
      const totalNum = theme.Currency.formatMoney(dataPrice, theme.moneyFormat);
      const priceNum = theme.Currency.formatMoney(
        dataPrice / dataFreq,
        theme.moneyFormat,
      );
      const totalOriNum = theme.Currency.formatMoney(
        dataOriPrice * dataFreq,
        theme.moneyFormat,
      );

      totalPriceElem.text(totalNum);
      singlePriceElem.text(priceNum);
      totalOriPriceElem.text(totalOriNum);
    };

    selectorMonth.on("change", function () {
      selectorVariants.addClass("hide");
      const selectorVariant = wrapper.find(
        `.selector-variant[data-sets-select="${this.value}"]`,
      );
      selectorVariant.removeClass("hide");

      updatePrice();
    });
    selectorVariants.on("change", function () {
      updatePrice();
    });
  }

  function handleSmartLockAddOn() {
    const addOnWrapper = $(".groupsell-wrap-second");
    const option_type = addOnWrapper.find(
      "input[name='prod-prism-door-closer-option-0']",
    );
    const option_colour = addOnWrapper.find(
      "input[name='prod-prism-door-closer-option-1']",
    );
    const option_colour_label = addOnWrapper.find(".prod-option-colour-box");
    const input = addOnWrapper.find("input[name='bundle_prod_2']");
    const clickPlus = addOnWrapper.find(".click-plus-2");
    const variantImages = addOnWrapper.find(
      "[data-groupsell-second-variant-image]",
    );
    const variantCompareAtPrices = addOnWrapper.find(
      "[data-variant-compare-at-prices]",
    );
    const variantPrices = addOnWrapper.find("[data-variant-prices]");
    const textOption0 = addOnWrapper.find(".prod-variant-selected-option-0");
    const textOption1 = addOnWrapper.find(".prod-variant-selected-option-1");

    function handleDynamicColourOption(type) {
      // type: slidearm or v-arm
      switch (type) {
        case "slidearm":
          textOption0.text("Slide Arm");
          break;
        case "v-arm":
          textOption0.text("V-Arm");
          break;
      }

      option_colour_label.addClass("hide");
      let hasClicked = false;
      option_colour_label.each(function (index, option) {
        const hasSubstring = Array.from(option.classList).some((className) =>
          className.includes(type),
        );
        if (hasSubstring) {
          $(option).removeClass("hide");
          if (!hasClicked) {
            $(option).click();
            hasClicked = true;
          }
        }
      });
    }

    function handleColourOptionChange(variantId, displayTitle) {
      input.val(variantId);
      const filteredTitle = displayTitle.match(/\((.*?)\)/);
      textOption1.text(filteredTitle[1]);

      variantImages.addClass("hide");
      variantCompareAtPrices.addClass("hide");
      variantPrices.addClass("hide");

      addOnWrapper
        .find(`[data-groupsell-second-variant-image="${variantId}"]`)
        ?.removeClass("hide");
      addOnWrapper
        .find(`[data-variant-compare-at-prices="${variantId}"]`)
        ?.removeClass("hide");
      addOnWrapper
        .find(`[data-variant-prices="${variantId}"]`)
        ?.removeClass("hide");
    }

    option_type.on("change", function () {
      handleDynamicColourOption($(this).val());
    });
    option_colour.on("change", function () {
      handleColourOptionChange($(this).val(), $(this).data("display-title"));
      if (clickPlus.hasClass("clicked")) {
        clickPlus.trigger("click");
        clickPlus.trigger("click");
      }
    });
    handleDynamicColourOption(option_type.val());
  }

  function handleFridgeImageCarousel() {
    const productImages = $(".product-images");
    if (!productImages.length) return;

    $(".variant-select .variant-item").each(function () {
      $(this).on("click", function () {
        const curVariant = this.dataset.selected
          .toLowerCase()
          .replace(" ", "-");
        productImages.find(".owl-carousel").each(function () {
          this.classList.add("hide");

          if (this.dataset.variant == curVariant) {
            this.classList.remove("hide");
            $(this).trigger("refresh.owl.carousel");
          }
        });
      });
    });
  }

  function handleTinglePopup() {
    const handlePrice2Popup = () => {
      const price2 = document.querySelector(".price-2");
      if (price2) {
        var modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ["overlay", "button", "escape"],
          closeLabel: "Close",
        });

        const popupContent = price2.querySelector(".popup-content");
        modal.setContent(popupContent.outerHTML);

        price2.addEventListener("click", function () {
          modal.open();
        });
      }
    };

    const handleCVPopup = () => {
      const cv_tooltips = document.querySelectorAll(".climate-voucher-tooltip");
      const cv_popup = document.querySelector(
        ".cv-info-container .cv-info-box",
      );

      if (cv_popup) {
        var modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ["overlay", "button", "escape"],
          closeLabel: "Close",
        });

        modal.setContent(cv_popup.outerHTML);

        cv_tooltips.forEach((tooltip) => {
          tooltip.addEventListener("click", function () {
            modal.open();
          });
        });
      }
    };

    const handleAPFilterAddOnPopup = () => {
      const addonTooltip = document.querySelector(
        ".filter-subscription-tooltip",
      );
      if (addonTooltip) {
        var modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ["overlay", "button", "escape"],
          closeLabel: "Close",
        });

        const popupContent = document.querySelector(
          ".filter-subscription-popup-container .filter-subscription-popup-box",
        );
        modal.setContent(popupContent.innerHTML);

        addonTooltip.addEventListener("click", function () {
          modal.open();
        });
      }
    };

    handlePrice2Popup();
    handleCVPopup();
    handleAPFilterAddOnPopup();
  }
  window.custom.handleTinglePopup = handleTinglePopup;

  function handleQ32() {
    $("#ProductSelect-product-template").on("change", function () {
      const variantId = $(this).val();
      if (variantId == "45530145226979") {
        $(".product-restocks > p").removeClass("hidden");
        $(".product-restocks .timerBox").addClass("hidden");
      } else {
        $(".product-restocks > p").addClass("hidden");
        $(".product-restocks .timerBox").removeClass("hidden");
      }
    });
    $("#ProductSelect-product-template").trigger("change");
  }

  function handleFreebieBanner() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      .free-gift {
        display: flex;
      }
      .free-gift img {
        max-width: 120px;
        max-height: 100px;
      }
      .free-gift .info-wrapper {
        width: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
      }
      .free-gift .info-wrapper .tag,
      .addon-container .info .tag {
        padding: 4px 12px;
        color: #fff;
        background: #7A0000;
        border-radius: 3px;
        font-size: 12px;
        font-weight: 700;
      }
      .free-gift .info-wrapper .title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 0;
        font-size: 14px;
        font-weight: 600;
      }
      .free-gift .info-wrapper .title span[data-popup] {
        display: inline-flex;
      }
      .free-gift .info-wrapper .title span[data-popup] svg {
        fill: #c4c4c4;
        width: 20px;
        height: 20px;
      }
      .free-gift .info-wrapper .description {
        margin: 0;
        font-size: 12px;
      }
      @media (min-width: 1024px) {
        .free-gift img {
          max-width: 180px;
        }
        .free-gift .info-wrapper .tag {
          font-size: 16px;
        }
        .free-gift .info-wrapper .title {
          font-size: 16px;
        }
        .free-gift .info-wrapper .title span[data-popup] svg {
          width: 25px;
          height: 25px;
        }
      }
    `;
    //document.head.append(style);

    const url = location.pathname;
    const prodHandle = url.split("/").pop();
    /*
    const banner = document.createElement("div");
    banner.classList.add("free-gift");
    banner.innerHTML = `
      <img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Freebie_Asset_jpg.png?v=1774603344" alt="" width="" height="" />
      <div class="info-wrapper">
        <span class="tag">FREE UPGRADE</span>
        <p class="title">
          Sentinel Pro Copper Rose
          <span data-popup="sentinel-vs-sentinel-pro">
            <svg class="common-tooltip" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 16.6666C13.9449 16.6666 17.1429 13.4686 17.1429 9.52372C17.1429 5.57883 13.9449 2.38086 10 2.38086C6.05514 2.38086 2.85718 5.57883 2.85718 9.52372C2.85718 13.4686 6.05514 16.6666 10 16.6666Z" fill="#C4C4C4"/>
              <path d="M9.99998 9.99958C9.99998 8.09482 11.4285 8.57101 11.4285 7.14244C11.4285 6.51744 10.9524 5.71387 9.99998 5.71387C9.0476 5.71387 8.57141 6.19006 8.09521 6.66625M9.99998 12.8567V11.4282Z" fill="#C4C4C4"/>
              <path d="M9.99998 9.99958C9.99998 8.09482 11.4285 8.57101 11.4285 7.14244C11.4285 6.51744 10.9524 5.71387 9.99998 5.71387C9.0476 5.71387 8.57141 6.19006 8.09521 6.66625M9.99998 12.8567V11.4282" stroke="white" stroke-width="1.42857"/>
            </svg>
          </span>
        </p>
        <p class="description">Free Upgrade to Sentinel Pro Copper Rose with every purchase of Sentinel Copper Rose</p>
      </div>
    `;
    */

    // $(banner)
    //   .find("[data-popup]")
    //   .on("click", function () {
    //     $(`#${$(this).attr("data-popup")}`).addClass("active");
    //   });

    // if (prodHandle == "prism-door-gate-lock-bundles") {
    //   $(".product-single__meta").after(banner);
    // } else if (prodHandle == "prism-sentry-series") {
    //   $(".groupsell-wrap .text-left").after(banner);
    // }
  }

  function handleNav2Content() {
    const container = document.querySelector(".nav2-content");
    container?.scrollTo({
      left: container.scrollWidth,
      behavior: "smooth",
    });
  }

  function handleSealSub() {
    document.addEventListener('sealsubs:selling_plan_changed', function(e) {
      const { selling_plan_id, element } = e.detail;
      console.log(e);
    });
  }

  function soundbarAddonTemp() {
    const excludeHandle = [];
    const handle = location.pathname.split("/").pop();

    if (excludeHandle.includes(handle)) return;

    let flow = $(`.add-on-prism-flow .dynamic_topup .redtext`);
    if (flow.length) flow.html(flow.html().replace(`279`, `199`).replace(`399`, `279`));

    let rhythm = $(`.add-on-prism-rhythm .dynamic_topup .redtext`);
    if (rhythm.length) rhythm.html(rhythm.html().replace(`249`, `257`).replace(`279`, `499`));

    let ripple = $(`.add-on-prism-ripple .dynamic_topup .redtext`);
    if (ripple.length) ripple.html(ripple.html().replace(`399`, `299`).replace(`469`, `459`));

    let symphony = $(`.add-on-prism-symphony .dynamic_topup .redtext`);
    if (symphony.length) symphony.html(symphony.html().replace(`549`, `509`).replace(`659`, `629`));
  }
  // #endregion

  // #region Cart page
  function handleAmountOwing() {
    if (!isCartPage) return;

    setInterval(() => {
      if (typeof discountOnCartProApp === "undefined") return;
      const codes = discountOnCartProApp.codes;
      if (!codes) return;
      if (codes.includes("CLIMATE400")) {
        $(".owing-section").removeClass("hide");
      } else {
        $(".owing-section").addClass("hide");
      }
    }, 500);
  }

  function handleNEATermsPopup() {
    if (!isCartPage) return;

    $(".NEA-terms-link").on("click", function () {
      $(".NEATerms-overlay").removeClass("hide");
    });
    $(".NEATerms-closeBtn").on("click", function () {
      $(this).closest(".NEATerms-overlay").addClass("hide");
    });
    $(".NEATerms-container").on("click", function (event) {
      event.stopPropagation();
    });
    $(".NEATerms-overlay").on("click", function () {
      $(this).addClass("hide");
    });
  }

  async function handleTVSoundbarDiscount() {
    const discountCode = {
      // Q Ultra 2026
      "9092512514275 / 45530125336803": "Q43UFLOW",
      // "9092512514275 / 45530298450147": "Q43URHYTHM",
      "9092512514275 / 45530141163747": "Q43URIPPLE",
      "9092512514275 / 45530125467875": "Q43USYMPHONY",
      "9092522016995 / 45530125336803": "Q55UFLOW",
      // "9092522016995 / 45530298450147": "Q55URHYTHM",
      "9092522016995 / 45530141163747": "Q55URIPPLE",
      "9092522016995 / 45530125467875": "Q55USYMPHONY",
      "9092525588707 / 45530125336803": "Q65UFLOW",
      // "9092525588707 / 45530298450147": "Q65URHYTHM",
      "9092525588707 / 45530141163747": "Q65URIPPLE",
      "9092525588707 / 45530125467875": "Q65USYMPHONY",
      "9092525654243 / 45530125336803": "Q75UFLOW",
      // "9092525654243 / 45530298450147": "Q75URHYTHM",
      "9092525654243 / 45530141163747": "Q75URIPPLE",
      "9092525654243 / 45530125467875": "Q75USYMPHONY",
      "8662918758627 / 45530125336803": "Q85UFLOW",
      // "8662918758627 / 45530298450147": "Q85URHYTHM",
      "8662918758627 / 45530141163747": "Q85URIPPLE",
      "8662918758627 / 45530125467875": "Q85USYMPHONY",

      // Q Ultra
      "8662933995747 / 45530125336803": "Q100UFLOW",
      // "8662933995747 / 45530298450147": "Q100URHYTHM",
      "8662933995747 / 45530141163747": "Q100URIPPLE",
      "8662933995747 / 45530125467875": "Q100USYMPHONY",

      // Q QE
      "9092471324899 / 45530125336803": "Q43QEFLOW",
      // "9092471324899 / 45530298450147": "Q43QERHYTHM",
      "9092471324899 / 45530141163747": "Q43QERIPPLE",
      "9092471324899 / 45530125467875": "Q43QESYMPHONY",
      "9092494065891 / 45530125336803": "Q55QEFLOW",
      // "9092494065891 / 45530298450147": "Q55QERHYTHM",
      "9092494065891 / 45530141163747": "Q55QERIPPLE",
      "9092494065891 / 45530125467875": "Q55QESYMPHONY",
      "9092502028515 / 45530125336803": "Q65QEFLOW",
      // "9092502028515 / 45530298450147": "Q65QERHYTHM",
      "9092502028515 / 45530141163747": "Q65QERIPPLE",
      "9092502028515 / 45530125467875": "Q65QESYMPHONY",
      "9092506058979 / 45530125336803": "Q75QEFLOW",
      // "9092506058979 / 45530298450147": "Q75QERHYTHM",
      "9092506058979 / 45530141163747": "Q75QERIPPLE",
      "9092506058979 / 45530125467875": "Q75QESYMPHONY",

      // U 2026
      "9004734251235 / 45530125336803": "U55FLOW",
      // "9004734251235 / 45530298450147": "U55RHYTHM",
      "9004734251235 / 45530141163747": "U55RIPPLE",
      "9004734251235 / 45530125467875": "U55SYMPHONY",
      "9004736217315 / 45530125336803": "U65FLOW",
      // "9004736217315 / 45530298450147": "U65RHYTHM",
      "9004736217315 / 45530141163747": "U65RIPPLE",
      "9004736217315 / 45530125467875": "U65SYMPHONY",
      "9004737626339 / 45530125336803": "U75FLOW",
      // "9004737626339 / 45530298450147": "U75RHYTHM",
      "9004737626339 / 45530141163747": "U75RIPPLE",
      "9004737626339 / 45530125467875": "U75SYMPHONY",

      // U
      "8784739369187 / 45530125336803": "U55FLOW",
      // "8784739369187 / 45530298450147": "U55RHYTHM",
      "8784739369187 / 45530141163747": "U55RIPPLE",
      "8784739369187 / 45530125467875": "U55SYMPHONY",
      "8662934192355 / 45530125336803": "U75FLOW",
      // "8662934192355 / 45530298450147": "U75RHYTHM",
      "8662934192355 / 45530141163747": "U75RIPPLE",
      "8662934192355 / 45530125467875": "U75SYMPHONY",
      "8784743235811 / 45530125336803": "U86FLOW",
      // "8784743235811 / 45530298450147": "U86RHYTHM",
      "8784743235811 / 45530141163747": "U86RIPPLE",
      "8784743235811 / 45530125467875": "U86SYMPHONY",

      // U Ultra
      "8949347909859 / 45530125336803": "U55UFLOW",
      // "8949347909859 / 45530298450147": "U55URHYTHM",
      "8949347909859 / 45530141163747": "U55URIPPLE",
      "8949347909859 / 45530125467875": "U55USYMPHONY",
      "8949348106467 / 45530125336803": "U65UFLOW",
      // "8949348106467 / 45530298450147": "U65URHYTHM",
      "8949348106467 / 45530141163747": "U65URIPPLE",
      "8949348106467 / 45530125467875": "U65USYMPHONY",
      "8949348204771 / 45530125336803": "U75UFLOW",
      // "8949348204771 / 45530298450147": "U75URHYTHM",
      "8949348204771 / 45530141163747": "U75URIPPLE",
      "8949348204771 / 45530125467875": "U75USYMPHONY",
      "8949348401379 / 45530125336803": "U86UFLOW",
      // "8949348401379 / 45530298450147": "U86URHYTHM",
      "8949348401379 / 45530141163747": "U86URIPPLE",
      "8949348401379 / 45530125467875": "U86USYMPHONY",

      // AL
      "8662934487267 / 45530125336803": "55ALFLOW",
      // "8662934487267 / 45530298450147": "55ALRHYTHM",
      "8662934487267 / 45530141163747": "55ALRIPPLE",
      "8662934487267 / 45530125467875": "55ALSYMPHONY",
      "8662926196963 / 45530125336803": "65ALFLOW",
      // "8662926196963 / 45530298450147": "65ALRHYTHM",
      "8662926196963 / 45530141163747": "65ALRIPPLE",
      "8662926196963 / 45530125467875": "65ALSYMPHONY",

      // S
      "8662929113315 / 45530125336803": "S32FLOW",
      // "8662929113315 / 45530298450147": "S32RHYTHM",
      "8662929113315 / 45530141163747": "S32RIPPLE",
      "8662929113315 / 45530125467875": "S32SYMPHONY",
      "8662934028515 / 45530125336803": "S40FLOW",
      // "8662934028515 / 45530298450147": "S40RHYTHM",
      "8662934028515 / 45530141163747": "S40RIPPLE",
      "8662934028515 / 45530125467875": "S40SYMPHONY",
      "8662934126819 / 45530125336803": "S43FLOW",
      // "8662934126819 / 45530298450147": "S43RHYTHM",
      "8662934126819 / 45530141163747": "S43RIPPLE",
      "8662934126819 / 45530125467875": "S43SYMPHONY",
    };

    const cartData = await (await fetch("/cart.json")).json();

    const tv = cartData.items.find((x) => x.product_type == "Google TV");
    const soundbar = cartData.items.find((x) => x.product_type == "Soundbar");
    let newCode = discountCode[`${tv?.product_id} / ${soundbar?.id}`];

    if (new Date() >= new Date('2026-09-08T10:00:00+08:00')) {
      if (newCode) newCode += "-A";
    }
    
    const hasExistingCode = discountOnCartProApp.codes.some(
      (x) => x.startsWith("PRISM") || x.endsWith("OFF"),
    );
    const hasNewCode = newCode
      ? discountOnCartProApp.codes.some((x) => x == newCode)
      : false;

    if (newCode && !hasNewCode) {
      if (hasExistingCode) {
        const codesToRemove = discountOnCartProApp.codes.filter(
          (x) =>
            x.startsWith("PRISM") || x.endsWith("OFF"),
        );
        discountOnCartProApp.removeCodes(codesToRemove);
      }
      discountOnCartProApp.applyCode(newCode);
    }
  } 

  function handleMyHomeBundlePopup() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", main);
    } else {
      main();
    }

    const MY_HOME_BUNDLE_CATEGORIES = {
      Monitor: ["Monitors"],
      TV: ["Google TV"],
      Aircon: ["Air Conditioners"],
      Fridge: ["Refrigerator"],
      "Ceiling Fan": ["Ceiling Fans"],
      Laundry: [
        "Laundry",
        "Washer & Dryer",
        "Laundry Rack",
        "Washer & Laundry Rack Bundle",
      ],
      Lock: ["Locks"],
      "Air Purifier": ["Air Purifier"],
      Vacuum: ["Vacuums", "Robot Vacuum", "Vacuum Handheld"],
      Soundbar: ["Soundbar"],
    };

    const CART_COOKIE_NAME = "mhb_cart_snapshot";

    async function main() {
      const cartData = await getCartData();

      const prevCartSnapshot = getCartCookie();
      setCartCookie(cartData);

      const myHomeBundleResult = getMyHomeBundleResult(cartData);

      if (myHomeBundleResult.count > 0 && myHomeBundleResult.count < 3) {
        modifyMyHomeBundlePopup(myHomeBundleResult);

        if (hasCartChanged(prevCartSnapshot, cartData)) {
          // console.log(
          //   "Showing My Home Bundle pop-up for",
          //   myHomeBundleResult.count,
          //   "bundle(s)",
          // );

          setTimeout(() => {
            showMyHomeBundlePopup();
          }, 4000);
        }
      }
    }

    function getCartCookie() {
      const match = document.cookie.match(
        new RegExp(`(?:^|; )${CART_COOKIE_NAME}=([^;]*)`),
      );
      if (!match) return null;
      try {
        return JSON.parse(decodeURIComponent(match[1]));
      } catch {
        return null;
      }
    }

    function setCartCookie(cartData) {
      const snapshot = cartData.items
        .map(({ variant_id, quantity }) => ({ variant_id, quantity }))
        .sort((a, b) => a.variant_id - b.variant_id);
      const expires = new Date(Date.now() + 30 * 864e5).toUTCString();
      document.cookie = `${CART_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(snapshot))}; expires=${expires}; path=/`;
    }

    function hasCartChanged(prevSnapshot, cartData) {
      const currentSnapshot = cartData.items
        .map(({ variant_id, quantity }) => ({ variant_id, quantity }))
        .sort((a, b) => a.variant_id - b.variant_id);
      return JSON.stringify(prevSnapshot) !== JSON.stringify(currentSnapshot);
    }

    function modifyMyHomeBundlePopup({ count, categories }) {
      let productsLeft = 0;
      let discount = 0;
      let eligibleItems = 0;

      switch (count) {
        case 1:
          productsLeft = 2;
          discount = 5;
          eligibleItems = 1;
          break;
        case 2:
          productsLeft = 1;
          discount = 5;
          eligibleItems = 2;
          break;
        // case 3:
        //   productsLeft = 1;
        //   discount = 8;
        //   eligibleItems = 3;
        //   break;
        // case 4:
        //   productsLeft = 2;
        //   discount = 10;
        //   eligibleItems = 4;
        //   break;
        // case 5:
        //   productsLeft = 1;
        //   discount = 10;
        //   eligibleItems = 5;
        //   break;
      }

      $(".myhomebundle-box > .title").html(
        `You’re ${productsLeft} product${productsLeft > 1 ? "s" : ""} away from an <span class='red-text'>EXTRA ${discount}% OFF!</span>`,
      );
      $(".myhomebundle-box > .subtitle").html(
        `You have <b>${eligibleItems}</b> eligible item${eligibleItems > 1 ? "s" : ""} in your cart. Add <b>${productsLeft} more item${
          productsLeft > 1 ? "s" : ""
        }</b> from different categories to save more.`,
      );

      $(".myhomebundle-box > .subtitle").after(
        `<picture style="margin-top: 1rem; max-width: 800px;">
        <source media="(min-width: 768px)" srcset="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/myhomebundle_cart_popup_categories_desktop.png?v=1779781363">
        <img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/myhomebundle_cart_popup_categories_mobile__png.png?v=1779781367" alt="My Home Bundle">
      </picture>`,
      );

      const desktopSwiper = document.querySelector(
        ".myhomebundle-box .carousel-wrapper.desktop .swiper",
      ).swiper;
      const mobileSwiper = document.querySelector(
        ".myhomebundle-box .carousel-wrapper.mobile .swiper",
      ).swiper;

      hideCategories(desktopSwiper, mobileSwiper, categories);
    }

    function showMyHomeBundlePopup() {
      $(".myhomebundle-overlay").removeClass("hide");
    }

    function getMyHomeBundleResult(cartData) {
      const cartProductTypes = cartData.items.map((item) => item.product_type);

      const matchedCategories = Object.entries(MY_HOME_BUNDLE_CATEGORIES)
        .filter(([_, acceptedTypes]) =>
          cartProductTypes.some((type) => acceptedTypes.includes(type)),
        )
        .map(([category]) => category);

      return { count: matchedCategories.length, categories: matchedCategories };
    }

    async function getCartData() {
      return await (await fetch("/cart.json")).json();
    }

    function hideCategories(
      desktopSwiper,
      mobileSwiper,
      hiddenCategories = [],
    ) {
      // --- Desktop: simple hide + update ---
      desktopSwiper.slides.forEach((slide) => {
        const category =
          slide.querySelector(".category-item")?.dataset.category;
        if (category) {
          slide.style.display = hiddenCategories.includes(category)
            ? "none"
            : "";
        }
      });
      desktopSwiper.update();

      // --- Mobile: re-chunk and reinit ---
      mobileSwiper = updateMobileCarousel(mobileSwiper, hiddenCategories);

      return { desktopSwiper, mobileSwiper };
    }

    function updateMobileCarousel(mobileSwiper, hiddenCategories = []) {
      // 1. Collect ALL category items from all slides
      const allItems = [];
      mobileSwiper.slides.forEach((slide) => {
        slide.querySelectorAll(".category-item").forEach((item) => {
          allItems.push(item.cloneNode(true)); // clone to preserve original
        });
      });

      // 2. Filter out hidden categories
      const visibleItems = allItems.filter((item) => {
        const category = item.dataset.category;
        return !hiddenCategories.includes(category);
      });

      // 3. Re-chunk into groups of 4
      const chunks = [];
      for (let i = 0; i < visibleItems.length; i += 4) {
        chunks.push(visibleItems.slice(i, i + 4));
      }

      // 4. Rebuild the swiper-wrapper HTML
      const wrapper = mobileSwiper.wrapperEl;
      wrapper.innerHTML = "";

      chunks.forEach((chunk, index) => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";

        const group = document.createElement("div");
        group.className = "category-item-group";

        chunk.forEach((item) => group.appendChild(item));
        slide.appendChild(group);
        wrapper.appendChild(slide);
      });

      // 5. Destroy and reinitialize
      const swiperEl = mobileSwiper.el;
      mobileSwiper.destroy(true, false);

      return new Swiper(swiperEl, {
        // ...your mobile swiper config
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: ".carousel-wrapper.mobile .swiper-pagination",
          clickable: true,
        },
      });
    }
  }
  // #endregion

  window.addEventListener("DOMContentLoaded", function () {
    if (location.pathname == "/cart") {
      setTimeout(() => {
        const interval = setInterval(() => {
          if (typeof discountOnCartProApp !== 'undefined') {
            clearInterval(interval);
            handleTVSoundbarDiscount();
          }
        }, 100);

        setTimeout(() => clearInterval(interval), 10000); // gives up after 10s
      }, 2000);

      // document.body.addEventListener("docapp-discount-applying", (e) => {
      //   console.log("docapp-discount-applying", e);
      // });
      // document.body.addEventListener("docapp-discount-code-submit", (e) => {
      //   console.log("docapp-discount-code-submit", e);
      // });
      document.body.addEventListener("docapp-discount-applied", (e) => {
        console.log("docapp-discount-applied", e.discounts);
        if (e.discounts.length) {
          setTimeout(() => {
            handleTVSoundbarDiscount();
          }, 2000);
        }
      });
      // document.body.addEventListener("docapp-discount-success", (e) => {
      //   console.log("docapp-discount-success", e);
      // });
      // document.body.addEventListener("docapp-discount-failure", (e) => {
      //   console.log("docapp-discount-failure", e);
      // });
      // document.body.addEventListener("docapp-discount-code-remove", (e) => {
      //   console.log("docapp-discount-code-remove", e);
      // });
    }
  });

  function main() {
    calculateHeaderHeight();
    handleShopWithClimateVoucher();
    // handleClimateVoucherPopup();
    handleAmountOwing();
    handleProductUpsellBlock();
    handleNEATermsPopup();
    handleAPFilterSubscription();
    handleSmartLockAddOn();
    handleFridgeImageCarousel();
    handleTinglePopup();
    handleFreebieBanner();
    handleNav2Content();
    handleSealSub();
    soundbarAddonTemp();

    // enable mobile horizontal scroller for Fridges PDP
    $(".product-images .owl-carousel").owlCarousel({
      items: 1,
      loop: true,
      center: true,
      nav: true,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;" xml:space="preserve"><g transform="matrix(-1 -1.22465e-16 1.22465e-16 -1 451.846 451.847)"><g><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744   L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284   c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z" data-original="#000000" class="active-path" fill="#000000"/></g></g> </svg>',
        '<svg enable-background="new 0 0 451.846 451.847" version="1.1" viewBox="0 0 451.85 451.85" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><path d="m345.44 248.29-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z"/></svg>',
      ],
      dots: false,
    });

    // 2025-08-28: PRISM+ Q32, update lead time when variant change
    if (location.pathname.indexOf("/products/q32c-q32-google-tv") > -1) {
      handleQ32();
    }

    // if (location.pathname == "/cart" && !getCookie("mhb_no_popup")) {
    if (location.pathname == "/cart") {
      handleMyHomeBundlePopup();
    }
  }

  if (document.readyState === 'loading') {
    // DOM not ready yet, wait for it
    document.addEventListener('DOMContentLoaded', main);
  } else {
    // DOM already loaded, run immediately
    main();
  }
})();
